// DS1.12.2
import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import FavStarFill from '@wix/da-ds/pkg/Icons/24x24/FavStarFill';
import GallectionCoverDumbo from '../../GallectionCoverDumbo';
import s from './GallectionCover.scss';

export interface Props {
  gallection: PapiGallection;
}

const GallectionCover: React.FC<Props> = ({ gallection }) => {
  return (
    <GallectionCoverDumbo
      width={70}
      height={40}
      gallection={gallection}
      className={s['cover']}
      placeholderClassName={s['cover-placeholder']}
      placeholder={<FavStarFill />}
    />
  );
};
GallectionCover.displayName = 'GallectionCover';

export default GallectionCover;
